import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { asField } from 'informed';

const DivOptionFather = styled.div`
	display: flex;
	flex-direction: column;
	top: 54px;
	height: 200px;
	width: 100%;
	background: white;
  font-family: Public Sans;
	font-size: 14px;
  border-radius: 11px;
  padding-top: 8px;
  border: 2px solid #E5E7EB;
  background: #FFF;
	overflow: auto;  
`;

const DivOption = styled.div`
	padding-left: 20px;
	gap: 5px;
	display: flex;
	justify-content: start;
	align-items: center;	
	height: 50px;	
`;

const LabelSelect = styled.label`
  color: #727780;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 500;
`;

const LabelStyle = styled.label`
  /* color: ${props => (props.checked ? '#0047B6' : '#727780')}; */
  color: #727780;
  margin-bottom: -1px;
`;

const InputCheckBox = asField(({ field, fieldState, fieldApi, checked, ...props }) => {
  const { value } = fieldState;
  const { setValue } = fieldApi;
  const {
    label,
    options,
    disabled,
    required,
    ...rest
  } = props;

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [optionsApi, setOptionsApi] = useState([]);

  const handleOption = (option) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
      setValue(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
      setValue([...selectedOptions, option]);
    };
    fieldApi.setError(null);
    fieldApi.setTouched();
  };

  useEffect(() => {
    if (disabled) {
      setSelectedOptions([]);
      setOptionsApi([]);
    }
    else {
      setOptionsApi(options);
    }
  }, [options]);

  useEffect(() => {
    setSelectedOptions(value || checked || []);
  }, []);

  return (
    <>
      <LabelSelect>{label}{required && <span style={{ color: "red" }}>*</span>}</LabelSelect>
      {optionsApi ? (
        <DivOptionFather>
          {optionsApi.map((option, index) => (
            <DivOption
              key={option.value}
            // onClick={() => {
            //   handleOption(option.value);
            // }}
            >
              <input
                id={`${option.value}${option.label}${index}`}
                style={{ fontSize: "13px", height: "35px" }}
                type="checkbox"
                value={option.value}
                checked={selectedOptions.includes(option.value)}
                onClick={() => { handleOption(option.value) }}
                {...rest}
              />
              <LabelStyle htmlFor={`${option.value}${option.label}${index}`}>{option.label}</LabelStyle>
            </DivOption>
          ))}
        </DivOptionFather>
      ) : (
        <DivOptionFather style={{ height: "35px", paddingLeft: "10px", paddingTop: "5px" }}>
          <span style={{ fontSize: "13px", height: "35px", opacity: "60%" }}>Nenhum resultado encontrado</span>
        </DivOptionFather>
      )}
    </>
  );
});

export default InputCheckBox;